import { Container } from "react-bootstrap";
import IntegrateForm from "../../components/Integrate-form";
import { useState, useEffect } from "react";
import { FailedNotify, SuccessNotify } from "../../constants/tostify";
import { useNavigate } from "react-router-dom";
import { useLazyGetShopCategoriesQuery, useCreateShopMutation } from "../../features/shop/shopApiSlice";
import { useSelector } from "react-redux";

const FarmingIntegrateform = () => {
  const navigate = useNavigate();
  const { name } = useSelector((state) => state.user);
  const [shopCategoryone, setShopCategoryone] = useState();
  const imageUrl = useSelector((state) => state.imgurl);
  const [integrateshop, setIntegrateshop] = useState({
    userid: name._id,
    shopaddress: "",
    shopUrl: "",
    isIntegrated: true,
    image: [""],
    shopCategory: "",
    businessType: "farmingShop",
    description: "",
    status: true,
  });

  useEffect(() => {
    setIntegrateshop((integrateshop) => ({
      ...integrateshop,
      image: imageUrl?.imgurl || "",
    }));
    // ...
  }, [imageUrl]);

  const [getShopCategories] = useLazyGetShopCategoriesQuery();
  const [createShopMutation] = useCreateShopMutation();

  const HandlePost = async () => {
    try {
      const response = await createShopMutation(integrateshop).unwrap();
      if (response?.success) {
        SuccessNotify("Shop Integrated Successfully");
        navigate("/farming-integrate-form");
      }
    } catch (error) {
      FailedNotify("Failed to create Try Again!");
    }
  };

  useEffect(() => {
    getShopCategories({ type: 'farmingShop' }).unwrap()
      .then((response) => {
        if (response?.success) {
          setShopCategoryone(response?.data?.Category);
        }
      })
      .catch((error) => { });
  }, []);
  return (
    <>
      <Container>
        <div className="screenHeight">
          <IntegrateForm
            backurl="/farming-integrate"
            setIntegrateshop={setIntegrateshop}
            shopCategoryone={shopCategoryone}
            HandlePost={HandlePost}
          />
        </div>
      </Container>
    </>
  );
};

export default FarmingIntegrateform;
